const UrlParams = {
  /**
   * Return one url param value (or null if not exists)
   * @param {string} param_name
   * @return {string|null}
   */
  get: function(param_name) {
    let url_string = window.location.href;
    try {
      let url = new URL(url_string);
      return url.searchParams.get(param_name);
    } catch (e) {
      let url_params = this.parseQueryStringOld(window.location.search);
      if (url_params[param_name]) {
        return url_params[param_name];
      }
      return null;
    }
  },

  /**
   * Return all url params as key-value object
   * @return {Object}
   */
  getAll: function() {
    let url_string = window.location.href,
      result;
    try {
      result = this.parseQueryStringModern(url_string);
    } catch (e) {
      result = this.parseQueryStringOld(url_string);
    }
    return result;
  },
  urlFromObject(obj, sep = "&") {
    let url = "";
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (url !== "") {
          url += sep;
        }
        url += key + "=" + encodeURIComponent(obj[key]);
      }
    }
    return url;
  },

  /**
   * For modern browsers
   * @param {string} query
   */
  parseQueryStringModern(query) {
    let url = new URL(query);
    let result = {};
    for (let pair of url.searchParams.entries()) {
      let [key, value] = pair;
      result[key] = value;
    }
    return result;
  },

  /**
   * For IE and other old browsers
   * @param {string} query
   */
  parseQueryStringOld(query) {
    const vars = query.split("&");
    let query_string = {};
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      let key = decodeURIComponent(pair[0]);
      let value = decodeURIComponent(pair[1]);
      // If first entry with this name
      if (typeof query_string[key] === "undefined") {
        query_string[key] = decodeURIComponent(value);
        // If second entry with this name
      } else if (typeof query_string[key] === "string") {
        query_string[key] = [query_string[key], decodeURIComponent(value)];
        // If third or later entry with this name
      } else {
        query_string[key].push(decodeURIComponent(value));
      }
    }
    return query_string;
  },
};

export default UrlParams;
